<template>
  <div>Preparando el sistema</div>
</template>

<script>
export default {
    data(){return{
        complete:false
    }},

    async mounted(){
      const token = localStorage.getItem("hope");
      if(token) {
          // verificar token
          // verificar
          this.$router.push("/app");
      }else{
          this.$router.push("/login");
      }
    },
    methods:{
        async verificarToken(token){

        },
        async revalidarToken(){

        }

    }
}
</script>

<style>

</style>